import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {updateCheckInReminder} from '/redux/action/candidate.action';
import {credentialsEmail} from '/redux/selector/auth.selector';
import {
  candidateNameById,
  hasReminderDetails,
  reminderDetailsById,
  reminderStatusById,
} from '/redux/selector/candidate.selector';
import {fromProps, withProps} from '/util/selector.util';

import CheckInReminder from './CheckInReminder';

const withCandidateId = withProps({
  candidateId: fromProps(get('candidateId')),
});

export default connect(
  createStructuredSelector({
    coachEmail: credentialsEmail,
    reminderDetails: reminderDetailsById,
    candidateName: withCandidateId(candidateNameById),
    reminderStatus: withCandidateId(reminderStatusById),
    hasReminderDetails: withCandidateId(hasReminderDetails),
  }),
  dispatch => ({
    updateCheckInReminder: ({reminderData, candidateId, reportData}: any) =>
      dispatch<any>(
        updateCheckInReminder({
          reminderData,
          candidateId,
          allReportData: reportData,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      updateCheckInReminder: ({reminderData, candidateId}: any) => {
        const {allReportData} = stateProps;
        return dispatchProps.updateCheckInReminder({
          reminderData,
          candidateId,
          reportData: allReportData,
        });
      },
    };
  },
)(CheckInReminder);
